import { Box, styled, TableCell } from '@mui/material';

export const ThreatUrlCell = styled(TableCell)({
  minWidth: '300px',
  '&:hover': {
    '& .action-buttons': {
      visibility: 'visible',
    },
  },
});

export const ActionButtons = styled(Box)({
  visibility: 'hidden',
  alignSelf: 'center',
  display: 'flex',
  gap: 1,
});

export const focusedRowSx = {
  backgroundColor: (theme: any) =>
    theme.palette.mode === 'dark'
      ? 'rgba(144, 202, 249, 0.08)'
      : 'rgba(25, 118, 210, 0.04)',
  '& > td:first-of-type': {
    borderLeft: '3px solid',
    borderLeftColor: 'primary.main',
  },
};
